import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Fa from 'react-fontawesome';
import {
  FormGroup, ControlLabel, FormControl,
  HelpBlock, Collapse, Panel, Tabs, Tab,
} from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { indexOf, without, concat, keys } from 'lodash';
import { Field } from 'redux-form';

import SearchForm from '../../../../components/search-form';
import DoNotContactField from './fields/DoNotContactField';
import SameAccountField from './fields/SameAccountField';
import ContactRoleField from './fields/ContactRoleField';
import AccountOpportunityField from './fields/AccountOpportunityField';
import LookbackField from './fields/LookbackField';
import ActivityThresholdField from './fields/ActivityThresholdField';
import ActivityTypeField from './fields/ActivityTypeField';
import ContactReferenceField from './fields/ContactReferenceField';
import GongContactOwnerField from './fields/GongContactOwnerField';
import { getUserCurrentOrganization } from '../../../Auth/AuthReducer';

import styles from './styles.css';

class ContactTriggerOptions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedTab: 'gong',
    };
    this.renderField = this.renderField.bind(this);
    this.toggle = this.toggle.bind(this);
    this.handleSyncDateClick = this.handleSyncDateClick.bind(this);
    this.handleTabSelect = this.handleTabSelect.bind(this);
  }

  toggle(name, options, option) {
    const exists = indexOf(options, option) >= 0;
    const newOptions = exists ? without(options, option) : concat(options, option);
    // https://github.com/lumen-software/TruSales/issues/1701
    // if (newOptions.length === 0) {
      // newOptions = map(allOptions, 'value');
    // }
    this.props.onChange(name, newOptions);
  }

  handleSyncDateClick(e) {
    e.stopPropagation();
    e.preventDefault();
    this.props.requestShowSyncTab();
  }
  
  handleTabSelect(selectedTab) {
    this.setState({ selectedTab });
  }

  getContactFormInnerFields(type) {
    const {
      submitting, contactFromExternalAccount, opportunityContactTypes,
      fullAutomationSingleOpportunity,
      dateRangeLabel, isAccount, disabled, gongRequireOpportunityOwner,
    } = this.props;

    const innerFields = [];

    if (type === 'automations/discovery-bot/contacts/custom_contact_object_references') {
      innerFields.push((
        <div key="custom-ref" style={{ marginBottom: '10px' }}>
          <ContactReferenceField
            isAccount={isAccount}
            value={this.props.contactReferenceFields}
            onChange={(vals) => {
              this.props.onChange('full_automation_contact_reference_fields', vals);
            }}
            disabled={submitting || disabled}
          />
          <hr />
        </div>
      ));
    } else if (type === 'automations/discovery-bot/contacts/gong_contacts') {
      innerFields.push((
        <div key="gong-contacts" style={{ marginBottom: '10px' }}>
          <GongContactOwnerField
            value={gongRequireOpportunityOwner}
            path={[]}
            level={1}
            showDelete={false}
            showInclude={false}
            disabled={submitting || disabled}
            editable={false}
            active={this.state.selectedTab === 'gongContact'}
            searchCriteria={{
              _id: 'gong-contact-require-owner',
              type: 'include',
              filter: {
                _id: 'gong-contact-require-owner',
                label: 'Require Opportunity Owner',
              },
            }}
            onToggle={() => {
              this.props.onChange('gong_require_opportunity_owner', !this.props.gongRequireOpportunityOwner);
            }}
            searchType={type}
          />
        </div>
      ));
    }

    if (type === 'automations/discovery-bot/contacts/opportunity_contacts') {
      innerFields.push((
        <div key="contact-role" style={{ marginBottom: '10px' }}>
          <ContactRoleField
            value={opportunityContactTypes}
            path={[]}
            level={1}
            showDelete={false}
            showInclude={false}
            disabled={submitting || disabled}
            editable={false}
            searchCriteria={{
              _id: 'contact-role',
              type: 'include',
              filter: {
                _id: 'contact-role',
                label: 'Contact Roles',
              },
            }}
            allRoles={this.props.allRoles}
            contactRoles={this.props.contactRoles}
            onContactTypeChange={(vals) => {
              this.props.onChange('full_automation_opportunty_contact_types', vals);
            }}
            onRolesChange={(roles) => {
              this.props.onChange('full_automation_contact_roles', roles);
            }}
            searchType={type}
          />
        </div>
      ));

      innerFields.push((
        <div key="same-account-contact" style={{ marginBottom: '10px' }}>
          <SameAccountField
            value={contactFromExternalAccount}
            path={[]}
            level={1}
            showDelete={false}
            showInclude={false}
            disabled={submitting || disabled}
            editable={false}
            searchCriteria={{
              _id: 'same-account-contact',
              type: 'include',
              filter: {
                _id: 'same-account-contact',
                label: 'External Contacts',
              },
            }}
            onToggle={() => {
              this.props.onChange('full_automation_contact_from_external_account', !this.props.contactFromExternalAccount);
            }}
            searchType={type}
          />
        </div>
      ));

      if (isAccount) {
        innerFields.push((
          <div key="account-opportunity" style={{ marginBottom: '10px' }}>
            <AccountOpportunityField
              value={fullAutomationSingleOpportunity}
              path={[]}
              level={1}
              showDelete={false}
              showInclude={false}
              disabled={submitting || disabled}
              editable={false}
              searchCriteria={{
                _id: 'account-opportunity',
                type: 'include',
                filter: {
                  _id: 'account-opportunity',
                  label: 'Account Opportunities',
                },
              }}
              dateRangeLabel={dateRangeLabel}
              onChange={(val) => {
                this.props.onChange('full_automation_single_opportunity', val);
              }}
              requestShowSyncTab={() => {
                this.props.requestShowSyncTab();
              }}
              searchType={type}
            />
          </div>
        ));  
      }
    } else if (type === 'automations/discovery-bot/contacts/contacts_with_activities') {
      innerFields.push((
        <div key="lookback" style={{ marginBottom: '10px' }}>
          <LookbackField
            value={null}
            path={[]}
            level={1}
            showDelete={false}
            showInclude={false}
            disabled={submitting || disabled}
            editable={false}
            dateRangeLabel={dateRangeLabel}
            searchCriteria={{
              _id: 'lookback',
              type: 'include',
              filter: {
                _id: 'lookback',
                label: 'Lookback Period',
              },
            }}
            searchType={type}
          />
        </div>
      ));

      innerFields.push((
        <div key="activity-threshold" style={{ marginBottom: '10px' }}>
          <ActivityThresholdField
            value={null}
            path={[]}
            level={1}
            showDelete={false}
            showInclude={false}
            disabled={submitting || disabled}
            editable={false}
            searchCriteria={{
              _id: 'lookback',
              type: 'include',
              filter: {
                _id: 'activity-threshold',
                label: 'Activity Threshold',
              },
            }}
            searchType={type}
          />
        </div>
      ));
      innerFields.push((
        <div key="activity-type" style={{ marginBottom: '10px' }}>
          <ActivityTypeField
            value={this.props.activityTypes}
            path={[]}
            level={1}
            showDelete={false}
            showInclude={false}
            disabled={submitting || disabled}
            editable={false}
            searchCriteria={{
              _id: 'lookback',
              type: 'include',
              filter: {
                _id: 'activity-type',
                label: 'Contact Activity Types',
              },
            }}
            onChange={(vals) => {
              this.props.onChange('full_automation_activity_types', vals);
            }}
            searchType={type}
          />
        </div>
      ));
    } 

    
    innerFields.push((
      <div key="do-not-contact" style={{ marginBottom: '10px' }}>
        <DoNotContactField
          value={true}
          path={[]}
          level={1}
          showDelete={false}
          showInclude={false}
          disabled={submitting || disabled}
          editable={false}
          searchCriteria={{
            _id: 'do-not-contact',
            type: 'include',
            filter: {
              _id: 'do-not-contact',
              label: 'Do Not Contact',
            },
          }}
          searchType={type}
        />
      </div>
    ));

    

    return innerFields;
  }

  renderSearchForm(type, isGong = false) {
    const {
      submitting,
      formUpdate,
      formInfos,
      disabled,
    } = this.props;
    
    let query = formInfos[type]?.query || {};

    const innerFields = isGong ? null : this.getContactFormInnerFields(type);
    
    if (keys(query).length === 0) {
      query = {};
    }

    return (
      <div>
        <SearchForm
          key={`form-${formUpdate}`}
          dropup
          onSearchChange={() => {
            this.props.onSearchReady(type);
          }}
          simpleMode
          showRootLogicalORWarning
          disabled={submitting || disabled}
          standalone
          defaultCriteria={query}
          type={type}
          isDynamic
          startingNode={isGong ? 'Gong__Gong_Call__c' : 'Contact'}
          className={styles.field}
        >
          {innerFields}
        </SearchForm>
      </div>
    );
  }

  renderField({
    input, label, type, meta: { touched, error }, componentClass, placeholder, options,
  }) {
    const { submitting, disabled } = this.props;
    const validationState = (touched || type === 'hidden') && error ? 'error' : null;
    return (
      <FormGroup validationState={validationState}>
        {label !== null && label !== undefined && label.length > 0 && <ControlLabel>{label}</ControlLabel>}
        {componentClass !== 'select' && <FormControl {...input} componentClass={componentClass} placeholder={(placeholder || label)} type={type} disabled={(submitting || disabled)} />}
        {componentClass === 'select' &&
          <FormControl {...input} componentClass={componentClass} placeholder={(placeholder || label)} type={type} disabled={(submitting || disabled)}>
            {options !== null && options !== undefined && options.map(option => (<option key={option.value} value={option.value}>{option.label}</option>))}
          </FormControl>
        }
        {type !== 'hidden' && <FormControl.Feedback />}
        {(touched || type === 'hidden') && error && <HelpBlock>{error}</HelpBlock>}
      </FormGroup>
    );
  }

  renderMultiselect(label, name, options, selected, helpText = null, subPanel = true) {
    const { disabled } = this.props;

    const body = (
      <div>
        {options.map((option) => {
          const active = indexOf(selected, option.value) >= 0;
          const hasHelpText = option.help && option.help.length > 0;
          const hasSubPanel = option.subPanel !== undefined && option.subPanel;
          const lbl = (name === 'full_automation_contact_roles' && option.value && option.label !== option.value) ? (<span>{option.label} (<code>{option.value}</code>)</span>) : option.label;
          const innerLabel = (
            <span><Fa name={active ? 'check-square' : 'square-o'} className={active ? 'text-success' : ''} /> {lbl}</span>
          );
          const labelComp = option.value === null ? (<em>{innerLabel}</em>) : innerLabel;
          return (
            <div key={option.value}>
              <div
                style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}
                key={option.value}
                onClick={() => {
                  if (!disabled) {
                    this.toggle(name, selected, option.value, options);
                  }
                }}
              >
                {labelComp}
              </div>
              {option.items !== undefined &&
                <Collapse in={active}>
                  <div style={{ padding: '15px', paddingLeft: '30px' }}>
                    {option.items}
                  </div>
                </Collapse>
              }
              {(hasHelpText || hasSubPanel) &&
                <Collapse in={active}>
                  <div style={{ padding: '15px', paddingLeft: '30px' }}>
                    {hasHelpText && <div className="well well-sm">{option.help}</div>}
                    {hasSubPanel && option.subPanel}
                  </div>
                </Collapse>
              }
            </div>
          );
        })}
      </div>
    );
    if (subPanel) {
      return (
        <div className="panel panel-default">
          <div className="panel-heading">
            <div className="panel-title">
              {label}
            </div>
          </div>
          <div className="panel-body">
            {body}
          </div>
        </div>
      );
    }
    return (
      <div>
        <h4>{label}</h4>
        {helpText}
        <div>
          {body}
          {name === 'full_automation_contact_types' &&
            <Field
              name={name}
              type="hidden"
              component={this.renderField}
            />
          }
        </div>
      </div>
    );
  }

  renderExternalAccountToggle() {
    const { contactFromExternalAccount, disabled } = this.props;
    const active = contactFromExternalAccount === true;
    return (
      <div>
        <div
          style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}
          onClick={() => {
            if (!disabled) {
              this.props.onChange('full_automation_contact_from_external_account', !active);
            }
          }}
        >
          <Fa name={active ? 'check-square' : 'square-o'} className={active ? 'text-success' : ''} /> Allow submitting contact(s) that do not belong to the opportunity&rsquo;s account
        </div>
      </div>
    );
  }

  renderAccountOppotunityLimit() {
    const {
      isAccount, fullAutomationSingleOpportunity,
      dateRangeLabel,
    } = this.props;
    if (!isAccount) {
      return null;
    }


    const options = [
      { value: true, label: `Most Recent Won Opportunity` },
      { value: false, label: `All Won Opportunities ${dateRangeLabel !== null ? dateRangeLabel : ''}` },
    ];

    let tips = null;
    if (fullAutomationSingleOpportunity) {
      tips = (
        <span>Contacts associated with <strong>the most recent won opportunity</strong> will be submitted.</span>
      );
    } else {
      const anchor = dateRangeLabel !== null ? (
        <a href="" onClick={this.handleSyncDateClick}>{dateRangeLabel}</a>
      ) : null;
      tips = (
        <span>Contacts associated with <strong>all won opportunities</strong> {anchor} will be submitted.</span>
      );
    }

    return (
      <div>
        <p>&nbsp;</p>
        <Field
          label="Account Opportunities:"
          name="full_automation_single_opportunity"
          componentClass="select"
          options={options}
          component={this.renderField}
          input={{
            value: fullAutomationSingleOpportunity,
            onChange: (e) => {
              if (e.target.value) {
                this.props.onChange('full_automation_single_opportunity', e.target.value === 'true' || e.target.value === true);
              }
            },
          }}
        />
        {tips !== null && <div><em>{tips}</em></div>}
        <p>&nbsp;</p>
      </div>
    )
  }

  render() {
    const {
      contactTypes, isAccount, disabled,
      organization,
    } = this.props;

    const contactTypesOptions = [
      {
        value: 'opportunity_contacts',
        label: 'Opportunity Contacts',
        help: (
          <div>
            Contacts associated with the closed opportunity in a contact role will automatically be submitted.
          </div>
        ),
      },
      {
        value: 'account_contacts',
        label: 'Account Contacts',
        help: (
          <div>
            {!isAccount && <span>Opportunity&rsquo;s account contacts will be submitted.</span>}
            {isAccount && <span>Account contacts will be submitted.</span>}
          </div>
        ),
      },
      {
        value: 'contacts_with_activities',
        label: 'Contacts with Activities',
        help: (
          <div>
            Contacts with an activity count higher than the activity threshold set below will automatically be submitted. Only the opportunity owner&rsquo;s activity is used to determine the activity count.
          </div>
        ),
      },
      ...(organization.has_gong_contacts ? [
        {
          value: 'gong_contacts',
          label: 'Gong Meeting Participants',
          help: (
            <div>
              Gong Meeting Participants
            </div>
          ),
        },
      ] : []),
      {
        value: 'custom_contact_object_references',
        label: 'Custom Contact Object References',
        help: (
          <div>
            <p>Contacts associated with the closed opportunity in a custom contact object reference field will automatically be submitted.</p>
            <p>If you cannot find the field(s) you are looking for, you can also <Link to={`/setup/sync-settings/Opportunity`}>add more custom fields to the sync</Link>.</p>
          </div>
        ),
      },
    ];
    
    return (
      <div>
        <div className="well well-sm"><Fa name="info-circle" /> Contacts that match the conditions below will automatically be submitted for feedback requests for the sales rep:</div>
        <div>
          {false && <h4>Contact Submission Methodology:</h4>}
          <div>
            {false && <p>Contacts for the qualified opportunity will be submitted using the following settings:</p>}
            <div>
              {contactTypesOptions.map((option) => {
                const active = indexOf(contactTypes, option.value) >= 0;
                const isGong = option.value === 'gong_contacts';
                const mainForm = this.renderSearchForm(`automations/discovery-bot/contacts/${option.value}`);

                const labelComp = (
                  <span><Fa name={active ? 'check-square' : 'square-o'} className={active ? 'text-success' : ''} /> {option.label}</span>
                );
                return (
                  <Panel key={option.value} expanded={active}>
                    <Panel.Heading>
                      <Panel.Title>
                        <div
                          style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}
                          key={option.value}
                          onClick={() => {
                            if (!disabled) {
                              this.toggle('full_automation_contact_types', contactTypes, option.value, contactTypesOptions);
                            }
                          }}
                        >
                          {labelComp}
                        </div>
                      </Panel.Title>
                    </Panel.Heading>
                    <Panel.Collapse>
                      <Panel.Body collapsible>
                        {option.help !== undefined && option.help !== null &&
                          <div className="well well-sm">
                            {option.help}
                          </div>
                        }
                        {isGong && 
                          <Tabs
                            id="gong-tabs"
                            animation={false}
                            onSelect={this.handleTabSelect}
                            activeKey={this.state.selectedTab}
                          >
                            <Tab
                              eventKey="gong"
                              title="Gong Trigger Conditions"
                            >
                              <div>
                                <p />
                                {this.renderSearchForm(`automations/discovery-bot/contacts/gong`, isGong)}
                              </div>
                            </Tab>
                            <Tab
                              eventKey="gongContact"
                              title="Gong Contact Trigger Conditions"
                            >
                              <div>
                                <p />
                                {mainForm}
                              </div>
                            </Tab>
                          </Tabs>
                        }
                        {!isGong && mainForm}
                      </Panel.Body>
                    </Panel.Collapse>
                  </Panel>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ContactTriggerOptions.propTypes = {
  dispatch: PropTypes.func.isRequired,
  onChange: PropTypes.func,
  submitting: PropTypes.bool,
  disabled: PropTypes.bool,
  activityTypes: PropTypes.arrayOf(PropTypes.string),
  contactRoles: PropTypes.arrayOf(PropTypes.string),
  contactReferenceFields: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string)),
  contactTypes: PropTypes.arrayOf(PropTypes.string),
  allRoles: PropTypes.arrayOf(PropTypes.shape({})),
  contactFromExternalAccount: PropTypes.bool,
  isAccount: PropTypes.bool,
  opportunityContactTypes: PropTypes.string,
  fullAutomationSingleOpportunity: PropTypes.bool,
  requestShowSyncTab: PropTypes.func,
  dateRangeLabel: PropTypes.string,
  formUpdate: PropTypes.number,
  onSearchReady: PropTypes.func,
  formInfos: PropTypes.shape({}),
  organization: PropTypes.shape({
    has_gong_contacts: PropTypes.bool,
  }).isRequired,
  gongRequireOpportunityOwner: PropTypes.bool,
};
ContactTriggerOptions.defaultProps = {
  onChange: () => {},
  requestShowSyncTab: () => {},
  submitting: false,
  disabled: false,
  contactFromExternalAccount: false,
  activityTypes: [],
  contactRoles: [],
  contactReferenceFields: [],
  contactTypes: [],
  allRoles: [],
  isAccount: false,
  opportunityContactTypes: 'roles-and-primary',
  dateRangeLabel: null,
  fullAutomationSingleOpportunity: false,
  formUpdate: 0,
  formInfos: {},
  onSearchReady: () => {},
  gongRequireOpportunityOwner: false,
};
ContactTriggerOptions.contextTypes = {
};

function mapStateToProps(state) {
  return {
    organization: getUserCurrentOrganization(state),
  };
}

export default connect(mapStateToProps)(ContactTriggerOptions);
